// @styles
require('./aggregatorCredentialsView.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { AggregatorAddEntityStepLogin } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepLogin/aggregatorAddEntityStepLogin'
import { OKButton } from 'commonsComponents/OKButton';
import { OKLink } from 'commonsComponents/OKLink';
import InsertEntityCredentialsSuccessView from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityCredentials/insertEntityCredentialsSuccessView';
import InsertEntityCredentialsErrorView from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityCredentials/insertEntityCredentialsErrorView';

// @actions
import {
    getDataBank,
    setFormValue,
    sendFormInfo,
    clearAddEntity,
    clearFormValues
} from 'actions/aggregator/aggregatorAddEntity'

// @utilities
import { recordLink, PROC_ADD_ENTITY_ERROR, PROC_RESTART } from 'utilities/tagging';
import { isFormFilled } from 'utilities/aggregator/aggregatorFormHelper';
const { FormattedText } = require('core/i18n').i18n;

class AggregatorScrappingPsd2CredentialsView extends React.PureComponent {

    componentDidMount() {
        !this.props.bank && this.props.history.push("/myprofile/global")
    }

    componentWillUnmount() {
        this.props.clearAddEntity()
    }

    handleOnAccept = () => {
        const { sendFormInfo, immAggregatorAddEntity, bank } = this.props
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])

        sendFormInfo(immLoginStep.get('publicKey'), immLoginStep.get('code'), immAggregatorAddEntity.get('values'), bank.get('userBankId'))
    }

    handleOnClickMainButton = () => {
        recordLink(PROC_ADD_ENTITY_ERROR, PROC_RESTART)
        this.props.history.push('/myprofile/global/entities/add')
    }

    shouldShowInfoColumn = (isSubmitSuccessful, hasError) => isSubmitSuccessful || hasError ? false : true;

    renderContent = (isSubmitSuccessful, hasError) => {
        const { immAggregatorAddEntity, bank, getDataBank, setFormValue, clearFormValues } = this.props
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])
        const { name, imageUrl } = bank ? bank.toJS() : {};

        if (isSubmitSuccessful)
            return (<InsertEntityCredentialsSuccessView
                bankName={name}
                bankLogo={imageUrl}
                onMainButtonClick={() => this.handleOnClickMainButton()} />)

        if (hasError)
            return (<InsertEntityCredentialsErrorView />)

        const formButtonEnabled = isFormFilled(immLoginStep.get('form'), immAggregatorAddEntity.get('values'));

        return (
            <div className="aggregator-credentials-view">
                <AggregatorAddEntityStepLogin
                    getDataBank={getDataBank}
                    form={immLoginStep.get('form')}
                    beta={immLoginStep.get('beta')}
                    setFormValue={setFormValue}
                    clearFormValues={clearFormValues}
                    bankId={bank && bank.get('code')}
                    bankUniqueId={bank && bank.get('code')}
                    bankCode={bank && bank.get('code')}
                    name={bank && bank.get('name')}
                    url={bank && bank.get('imageUrl')}
                    isFetching={immLoginStep.get('isFetching')}
                    values={immAggregatorAddEntity.get('values')}
                    submitFetching={immLoginStep.get('fetchingform')}
                    showDisclaimer={true}
                    mustLoadBankData={true}
                />
                <footer className="aggregator-credentials-view__buttons row">
                    <div className="aggregator-credentials-view__buttons__left col-xs-6">
                        <OKLink
                            modifier="emphasize"
                            to="/myprofile/global/entities/manage"
                        >
                            <FormattedText value="aggregatorCredentials-back" />
                        </OKLink>
                    </div>
                    <div className="aggregator-credentials-view__buttons__right col-xs-6">
                        <OKButton
                            modifier="primary"
                            onClick={this.handleOnAccept}
                            disabled={!formButtonEnabled}
                        >
                            <FormattedText value="aggregatorCredentials-accept" />
                        </OKButton>
                    </div>
                </footer>
            </div>
        )
    }

    render() {
        const { immAggregatorAddEntity } = this.props
        const isSubmitSuccessful = immAggregatorAddEntity.get('submitSuccessful');
        const hasError = immAggregatorAddEntity.get('error');

        return (
            <AggregatorAddEntityLayout showInfoColumn={this.shouldShowInfoColumn(isSubmitSuccessful, hasError)}>
                {this.renderContent(isSubmitSuccessful, hasError)}
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorScrappingPsd2CredentialsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAggregatorAddEntity: PropTypes.object,
    bank: PropTypes.object,
    clearAddEntity: PropTypes.func,
    getDataBank: PropTypes.func,
    sendFormInfo: PropTypes.func,
    setFormValue: PropTypes.func,
    clearFormValues: PropTypes.func,
    match: PropTypes.shape({
        params: PropTypes.shape({
            userBankId: PropTypes.string
        }),
    }),
}

export default withRouter(connect(
    (state, ownProps) => ({
        immAggregatorAddEntity: state.aggregatorAddEntity,
        bank: state.aggregatorData.getIn(['data', 'banks', ownProps.match.params.userBankId])
    }), {
    sendFormInfo,
    getDataBank,
    setFormValue,
    clearAddEntity,
    clearFormValues
}
)(AggregatorScrappingPsd2CredentialsView))
